'use strict';

angular.module('risevision.common.components.loading', ['angularSpinner'])
  .value('_rvGlobalSpinnerRegistry', []);
